export default "__VITE_ASSET__0622357c__"